import CsButton from './Button';

CsButton.install = (Vue) => {
  Vue.component(CsButton.name, CsButton);
};

export default CsButton;
